import { WorkDependencyType, WorkEntityType } from "@miplatform/types";
import { mdiChartSankeyVariant, mdiFormatListBulleted } from "@mdi/js";

export enum AutoTriggerView {
  List,
  Chart,
}

export const AUTO_TRIGGER_OFFSET_FROM_OPTIONS = [
  { value: "EffectiveScheduledDate", label: "Order Scheduled Date" },
  { value: "CompleteDate", label: "Order Completed Date" },
];

export const DEFAULT_AUTO_TRIGGER_FLOW = "Default Flow";

export const AUTO_TRIGGER_DISPLAY_MODE_OPTIONS = [
  {
    label: "List",
    icon: mdiFormatListBulleted,
    value: AutoTriggerView.List,
    sx: {
      minWidth: "70px",
    },
  },
  {
    label: "Chart",
    icon: mdiChartSankeyVariant,
    value: AutoTriggerView.Chart,
    sx: {
      minWidth: "70px",
    },
  },
] as const;

export const DEFAULT_ORDER_AUTO_TRIGGER_MAP_TYPES = {
  principalType: WorkEntityType.Order,
  dependentType: WorkEntityType.Order,
  dependencyType: WorkDependencyType.OrderToOrder,
} as const;
